import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';

export default function LocalHelmet({ children, ...helmetProps }) {
  return (
    <HelmetProvider>
      <Helmet {...helmetProps}>{children}</Helmet>
    </HelmetProvider>
  );
}